import { CanDeactivate} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  isModellingOngoing:  boolean;
}

@Injectable()
export class ModellingDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: CanComponentDeactivate): boolean {
    if(component.isModellingOngoing == true){
        if (confirm("You have unsaved changes! If you leave, your changes will be lost..")) {
            return true;
        } 
        else {
            return false;
        }
    }
    if(component.isModellingOngoing == false){
      return true;
    }
  }
}